import './payment-notices.css';

export default function PaymentNoticeBorder({ cornerRadius = 7 }) {
  return (
    <svg className="payment-notice-orbit" aria-hidden="true" focusable="false">
      <rect x="1" y="1" rx={cornerRadius} pathLength="100" />
    </svg>
  );
}
